<div class="section" [ngClass]="{'inUser':isUser$()}" [style.background]="backColor$ | async">
  <que-board-header *ngIf="!viewAnswer"></que-board-header>
  <que-view-answer-header *ngIf="viewAnswer"></que-view-answer-header>
  <div class="stepMobilePopUp" *ngIf="isOpenPageMenu">
    <div class="title">
      <span translate>
        menuTypes.stepsTitle
      </span>
      <img (click)="closePagesMenu()" src="/assets/images/steps/close.svg">
    </div>
    <div class="stepMobileMenu">
      <que-steps-menu [inMobile]="true" (closeMenuEvent)="closePagesMenu()"></que-steps-menu>
    </div>
  </div>
  <div class="warp-center">
    <div class="pages">
      <div class="title">
        <span translate>
          menuTypes.stepsTitle
        </span>
      </div>
      <div class="warp-menu">
        <que-steps-menu></que-steps-menu>
      </div>
    </div>
    <div class="space" #warpBoard>
      <que-question-board *ngIf="(notLoading$() &&  !globalansweload$()) else loading"
        [isPreview]="true" [viewAnswer]="viewAnswer"></que-question-board>
      <div class="pageination-bar">
        <div [ngClass]="{'disabled':(currentStepIndex$()??0)<1}" (click)="(currentStepIndex$()??0)<1?null:prev()">
          <svg-icon svgClass="page-btn" src="/assets/images/steps/prev.svg"></svg-icon>
        </div>
        <svg-icon svgClass="pointer" (click)="openPagesMenu()" src="/assets/images/steps/pages.svg"></svg-icon>
        <div [ngClass]="{'disabled':stepsLength$() == ((currentStepIndex$() ?? 0) + 1)}"
          (click)="stepsLength$() == ((currentStepIndex$() ?? 0) + 1)?null:next()">
          <svg-icon svgClass="page-btn" src="/assets/images/steps/next.svg"></svg-icon>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #loading>
  <que-loading-board></que-loading-board>
</ng-template>